export default function Timepoint({date, children}) {
    return (
        <li className="event" data-date={date}>
            {children}
        </li>
    );
}
